import script from "./cancel-ignore-dialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./cancel-ignore-dialog.vue?vue&type=script&setup=true&lang=ts"

import "./cancel-ignore-dialog.vue?vue&type=style&index=0&id=74f37cf9&scoped=true&lang=scss"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74f37cf9"]])

export default __exports__